import { Trans } from '@lingui/macro';
import { BankAccountStepWhenCVR } from './BankAccountStepWhenCVR';
import { BankAccountStepWhenSENumber } from './BankAccountStepWhenSENumber';
import { GetCurrentCompanyBankInformationResponse } from '../../types';
import { usePayrollOnboardingContext } from '../../context/OnboardingContext';

export const BankAccountStep = ({ bankData }: { bankData: GetCurrentCompanyBankInformationResponse }) => {
    const { companyInfoStepState } = usePayrollOnboardingContext();

    return (
        <>
            <h1 className="text-3xl mb-6 text-center">
                <Trans>Set up your bank account</Trans>
            </h1>
            {companyInfoStepState?.isCvr ? (
                <BankAccountStepWhenCVR bankData={bankData} />
            ) : companyInfoStepState?.isSe ? (
                <BankAccountStepWhenSENumber bankData={bankData} />
            ) : null}
        </>
    );
};
